export default {
  "wt-textarea": "_wt-textarea_othjbp_1",
  "wt-textarea__wrapper": "_wt-textarea__wrapper_othjbp_4",
  "wt-textarea__inner": "_wt-textarea__inner_othjbp_7",
  "wt-textarea_theme_light": "_wt-textarea_theme_light_othjbp_42",
  "wt-textarea_theme_dark": "_wt-textarea_theme_dark_othjbp_84",
  "wt-textarea_size_l": "_wt-textarea_size_l_othjbp_127",
  "wt-textarea_size_m": "_wt-textarea_size_m_othjbp_132",
  "wt-textarea_size_s": "_wt-textarea_size_s_othjbp_137",
  "wt-textarea_size_xs": "_wt-textarea_size_xs_othjbp_142",
  "wt-textarea_error": "_wt-textarea_error_othjbp_147",
  "wt-textarea__icon": "_wt-textarea__icon_othjbp_152",
  "wt-textarea_empty": "_wt-textarea_empty_othjbp_177",
  "wt-textarea__error-message": "_wt-textarea__error-message_othjbp_186",
  "wt-textarea__note": "_wt-textarea__note_othjbp_191",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_othjbp_232"
};